var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProfileName',{staticClass:"ma-0 text-center profileName",attrs:{"profileName":_vm.profileName}}),_c('ProfileEmail',{staticClass:"ma-0 text-center profileEmail",attrs:{"profileEmail":_vm.profileEmail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }